import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AccountRecovery } from '@/components/auth'
import { routeToRedirectUrl } from '@/utils'
import { localStorageService } from '@/services'
import { ROUTES, STORAGE_KEYS } from '@/constants'

export const AccountRecoveryPage = () => {
  const navigate = useNavigate()

  const redirectUrl = localStorageService.getItem(STORAGE_KEYS.REDIRECT_URL)

  const onSuccess = () => {
    if (redirectUrl) routeToRedirectUrl(redirectUrl)
    else navigate(ROUTES.HOME)
  }

  return <AccountRecovery redirectUrl={redirectUrl} onSuccess={onSuccess} />
}
